import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

export const ContactWrapper = styled.div`
  width: 870px;
  margin: 0 auto 60px;
  max-width: 100%;
  @media (max-width: 990px) {
    padding: 80px 45px 30px 45px;
  }
  @media (max-width: 575px) {
    padding: 60px 25px 0 25px;
  }
`;

export const ContactFromWrapper = styled.div`
  position: relative;
  .button {
    margin-top: 60px;
    @media (max-width: 575px) {
      margin-top: 40px;
    }
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .field-wrapper {
    flex-grow: 1;
    max-width: calc(50% - 30px);
    margin-bottom: 60px;
    @media (max-width: 575px) {
      max-width: 100%;
      margin-bottom: 40px;
    }
  }
`;

export const DateWrapper = styled.div`
  position: relative;
  > div {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;

    > label {
      color: ${themeGet("colors.textColor", "#292929")};
      font-size: ${themeGet("fontSizes.3", "15")}px;
      line-height: ${themeGet("lineHeights.normal", "1")};
      font-weight: ${themeGet("fontWeights.4", "500")};
    }
  }

  .react-datepicker__input-container {
    margin-top: 15px;
    margin-bottom: 60px;
    input {
      appearance: none;
      width: 100%;
      height: ${themeGet("heights.2", "44")}px;
      border: 1px solid ${themeGet("colors.borderColor", "#DBDBDB")};
      color: ${themeGet("colors.textColor", "#292929")};
      font-size: ${themeGet("fontSizes.3", "15")}px;
      line-height: ${themeGet("lineHeights.normalText", "1.5")};
      font-weight: ${themeGet("fontWeights.4", "500")};
      padding: 0 ${themeGet("space.4", "15")}px;
      box-sizing: border-box;
      border-radius: 0;
      transition: border-color 0.25s ease;
    }
  }
`;
